/** Brand palette aligned with the landing page hero image */
export const LANDING_BRAND = {
  primary: "#E8457A",
  primaryDark: "#C9386F",
  primaryRgb: "232, 69, 122",
  primaryLight: "rgba(232, 69, 122, 0.1)",
  cream: "#FFF9F5",
  peach: "#FFD8C2",
  coral: "#FF8C94",
} as const;
